import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { getDefaultScenarioYear } from '@/config/map';
import { getFirstSelectableFloodTimelineDayIsoForYear } from '@/features/map/utils/floodTimelineCalendar';

export type ScenarioMode = 'historical' | 'live' | 'regional';

export interface ScenarioState {
  mode: ScenarioMode;
  selectedYear: number | null;
  selectedDate: string | null;
  selectedRegion: string | null;
  /** Calendar day (YYYY-MM-DD) for 24h history strip. */
  timeSliderHistoryDay: string;
  timeSliderPlaying: boolean;
}

const initialState: ScenarioState = {
  mode: 'live',
  selectedYear: null,
  selectedDate: null,
  selectedRegion: null,
  timeSliderHistoryDay: getFirstSelectableFloodTimelineDayIsoForYear(getDefaultScenarioYear()),
  timeSliderPlaying: false,
};

const scenarioSlice = createSlice({
  name: 'scenario',
  initialState,
  reducers: {
    setMode(state, action: PayloadAction<ScenarioMode>) {
      state.mode = action.payload;
    },
    setSelectedYear(state, action: PayloadAction<number | null>) {
      state.selectedYear = action.payload;
    },
    setSelectedDate(state, action: PayloadAction<string | null>) {
      state.selectedDate = action.payload;
    },
    setSelectedRegion(state, action: PayloadAction<string | null>) {
      state.selectedRegion = action.payload;
    },
    setTimeSliderHistoryDay(state, action: PayloadAction<string>) {
      state.timeSliderHistoryDay = action.payload;
    },
    setTimeSliderPlaying(state, action: PayloadAction<boolean>) {
      state.timeSliderPlaying = action.payload;
    },
  },
});

export const {
  setMode,
  setSelectedYear,
  setSelectedDate,
  setSelectedRegion,
  setTimeSliderHistoryDay,
  setTimeSliderPlaying,
} = scenarioSlice.actions;
export default scenarioSlice.reducer;
